export default "__VITE_ASSET__J3FH3ZQh__"